import { RuntimeError } from '@belimo-retrofit-portal/logic';
import { Location } from 'src/modules/routing/types/Location';

export class RouteNotFoundError extends RuntimeError {
  public constructor(
    public readonly location: Location,
  ) {
    super(`Route "${location.pathname}" not found`, { location });
  }

  public get name(): string {
    return 'RouteNotFoundError';
  }
}
